// production URI
// export const API_URL = "https://ssindustries.5techg.com/api/";

// dev URI
export const API_URL = "https://omgagangiri.5techg.com/api/";
